import {
  Home,
  About,
  TermsConditions,
  Faq,
  Contact,
  Organization,
  Event,
  EventRegister,
  Program,
  ProgramStatistic,
  ProgramStatisticOrganization,
  ProgramMap,
  Resource,
  Blog,
  OrganizationMap,
  OrganizationStatistic,
  OrganizationDetail,
  OrganizationDetailProgram,
  OrganizationDetailEvent,
  OrganizationDetailResource,
  EventDetail,
  BlogDetail,
  ResourceDetail,
  OrganizationDetailBlog,
  SearchResults,
  Register,
  RegisterOrganization,
  RegisterOrganizationConfirmation,
  Login,
  ForgotPassword,
  ProgramDetail,
  Dashboard,
  DashboardBookmarks,
  DashboardProfile,
  DashboardTickets,
  DashboardTicketsDetail,
  DashboardSettings,
  DashboardPrograms,
  DashboardProgramForm,
  DashboardEvents,
  DashboardEventForm,
  DashboardResources,
  DashboardResourceForm,
  DashboardBlog,
  DashboardBlogForm,
  DashboardMilestonesForm,
  DashboardPartnersForm,
  DashboardGuestList,
  DashboardLocationForm,
  DashboardVisibility,
  DashboardMessage,
  Profile,
  ProgramStory,
  ResourceLanding,
  // ResourceExpert,
  RegionDetail,
  // RegionDetailEvent,
  // RegionDetailBlog,
  RegionMap,
} from './pages'

const routes = [
  {
    path: "/dashboard/message",
    component: DashboardMessage
  },
  {
    path: "/dashboard/visibility",
    component: DashboardVisibility
  },
  {
    path: "/dashboard/blog/form",
    component: DashboardBlogForm
  },
  {
    path: "/dashboard/blog",
    component: DashboardBlog
  },
  {
    path: "/dashboard/resources/form",
    component: DashboardResourceForm
  },
  {
    path: "/dashboard/resources",
    component: DashboardResources
  },
  {
    path: "/dashboard/events/guest-list",
    component: DashboardGuestList
  },
  {
    path: "/dashboard/events/form",
    component: DashboardEventForm
  },
  {
    path: "/dashboard/events",
    component: DashboardEvents
  },
  {
    path: "/dashboard/programs/form",
    component: DashboardProgramForm
  },
  {
    path: "/dashboard/programs",
    component: DashboardPrograms
  },
  {
    path: "/dashboard/settings",
    component: DashboardSettings
  },
  {
    path: "/dashboard/tickets/detail",
    component: DashboardTicketsDetail
  },
  {
    path: "/dashboard/tickets",
    component: DashboardTickets
  },
  {
    path: "/dashboard/profile/partners/edit",
    component: DashboardPartnersForm
  },
  {
    path: "/dashboard/profile/location/edit",
    component: DashboardLocationForm
  },
  {
    path: "/dashboard/profile/contact",
    component: DashboardProfile,
    defaultTab: "Contact & Location"
  },
  {
    path: "/dashboard/profile/partners",
    component: DashboardProfile,
    defaultTab: "Partners"
  },
  {
    path: "/dashboard/profile/milestones/edit",
    component: DashboardMilestonesForm
  },
  {
    path: "/dashboard/profile/milestones",
    component: DashboardProfile,
    defaultTab: "Milestones"
  },
  {
    path: "/dashboard/profile",
    component: DashboardProfile
  },
  {
    path: "/dashboard/bookmarks",
    component: DashboardBookmarks
  },
  {
    path: "/dashboard",
    component: Dashboard
  },
  {
    path: "/blog/detail/:id",
    component: BlogDetail
  },
  {
    path: "/blog",
    component: Blog
  },
  // {
  //   path: "/resource/expert",
  //   component: ResourceExpert,
  //   exact: true
  // },
  {
    path: "/resource/detail/:id",
    component: ResourceDetail
  },
  {
    path: "/resource/:category",
    component: Resource,
  },
  {
    path: "/resource",
    component: ResourceLanding
  },
  {
    path: "/resources",
    component: Resource
  },
  {
    path: "/program-map",
    component: ProgramMap
  },
  {
    path: "/program-statistic-organization",
    component: ProgramStatisticOrganization
  },
  {
    path: "/program-statistic",
    component: ProgramStatistic
  },
  {
    path: "/program/story",
    component: ProgramStory
  },
  {
    path: "/program/:id/detail",
    component: ProgramDetail
  },
  {
    path: "/program",
    component: Program
  },
  {
    path: "/event/register",
    component: EventRegister
  },
  {
    path: "/event/detail/:id",
    component: EventDetail
  },
  {
    path: "/event",
    component: Event
  },
  {
    path: "/region/detail/:id/inisiatif",
    component: RegionDetail,
    contentRoute: 'Inisiatif'
  },
  {
    path: "/region/detail/:id/organisasi",
    component: RegionDetail,
    contentRoute: 'Organisasi'
  },
  {
    path: "/region/detail/:id/kasus",
    component: RegionDetail,
    contentRoute: 'Kasus'
  },
  {
    path: "/region/detail/:id/hasil penelitian",
    component: RegionDetail,
    contentRoute: 'Hasil Penelitian'
  },
  {
    path: "/region/detail/:id/buku",
    component: RegionDetail,
    contentRoute: 'Buku'
  },
  {
    path: "/region/detail/:id/experts",
    component: RegionDetail,
    contentRoute: 'Experts'
  },
  {
    path: "/region/detail/:id/kebijakan internasional",
    component: RegionDetail,
    contentRoute: 'Kebijakan Internasional'
  },
  {
    path: "/region/detail/:id/kebijakan nasional",
    component: RegionDetail,
    contentRoute: 'Kebijakan Nasional'
  },
  {
    path: "/region/detail/:id/kebijakan-kota-daerah",
    component: RegionDetail,
    contentRoute: 'kebijakan-kota-daerah'
  },
  {
    path: "/region/detail/:id/event",
    component: RegionDetail,
    contentRoute: 'Event'
  },
  {
    path: "/region/detail/:id/blog",
    component: RegionDetail,
    contentRoute: 'Blog'
  },
  {
    path: "/region-map",
    component: RegionMap
  },
  {
    path: "/region/detail/:id",
    component: RegionDetail
  },
  {
    path: "/organization/:id/detail/blog",
    component: OrganizationDetailBlog
  },
  {
    path: "/organization/:id/detail/produk",
    component: OrganizationDetailResource
  },
  {
    path: "/organization/:id/detail/event",
    component: OrganizationDetailEvent
  },
  {
    path: "/organization/:id/detail/inisiatif",
    component: OrganizationDetailProgram
  },
  {
    path: "/organization/:id/detail",
    component: OrganizationDetail
  },
  {
    path: "/organization-statistic",
    component: OrganizationStatistic
  },
  {
    path: "/organization-map",
    component: OrganizationMap
  },
  {
    path: "/organization",
    component: Organization
  },
  {
    path: "/profile",
    component: Profile
  },
  {
    path: "/about",
    component: About
  },
  {
    path: "/terms-conditions",
    component: TermsConditions
  },
  {
    path: "/faq",
    component: Faq
  },
  {
    path: "/contact",
    component: Contact
  },
  {
    path: "/search-results",
    component: SearchResults
  },
  {
    path: "/login/requirement",
    component: Login,
    required: true
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/register",
    component: Register
  },
  {
    path: "/register-organization",
    component: RegisterOrganization
  },
  {
    path: "/register-confirmation",
    component: RegisterOrganizationConfirmation
  },
  {
    path: "/forgot-password",
    component: ForgotPassword
  },
  {
    path: "/",
    component: Home
  },
]

export default routes
